import { useExportWP } from '@components/App/Modal/Share/hooks/useExportWP'
import { Modal, Switch } from '@lib/components'
import { FileXml } from '@lib/images'
import { Button, ThemeColors } from '@octopus-do/octopus-storybook'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import type React from 'react'
import { useState } from 'react'
import { useSelector } from 'react-redux'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { normalize } from '@/helpers'
import type { ModalProps } from '@/types/modal'
import css from './ExportAsWp.module.scss'

export const ExportAsWp: React.FC<ModalProps> = ({ onClose, onBack }) => {
  const projectName = useSelector(migrationProjectSelector.getProjectTitle)

  const [nestUnderHome, setNestUnderHome] = useState(false)
  const [withContent, setWithContent] = useState(true)

  const { handleSubmit } = useExportWP()

  const onSave = () => {
    sendGtmEvent(
      GtmTriggerName.EXPORT_WP,
      'Clicked on generate button in Save for WordPress modal.'
    )

    handleSubmit({ nestUnderHome, withContent })
      .then((blob: Blob) => {
        const link = document.createElement('a')

        link.download = `${normalize(projectName)}.xml`
        link.href = window.URL.createObjectURL(blob)
        link.click()
        window.URL.revokeObjectURL(link.href)
        onClose()
      })
      .catch((e: unknown) => {
        console.error(e)
      })
  }

  return (
    <Modal
      title="Export to WordPress"
      onClose={onClose}
      onBack={onBack}
      width={384}
      image={<FileXml />}
      classnames={{
        content: css.modalContent,
      }}
    >
      <div className={ThemeColors.light}>
        <div className={css.container}>
          <div className={css.item}>
            <div className={css.text}>
              <span className={css.title}>Content</span>
              <span className={css.description}>Include page content</span>
            </div>
            <Switch checked={withContent} onChange={setWithContent} />
          </div>

          <div className={css.item}>
            <div className={css.text}>
              <span className={css.title}>Nest under Home</span>
              <span className={css.description}>Put all pages under Home</span>
            </div>
            <Switch checked={nestUnderHome} onChange={setNestUnderHome} />
          </div>
        </div>

        <div className={css.footer}>
          <Button label="Save" onClick={onSave} />
        </div>
      </div>
    </Modal>
  )
}
